import axios from 'axios';

const USE_AWS = true;
const API_URL = process.env.REACT_APP_API_URL || 
  (USE_AWS && 'https://tmpwamartcimpbcyypdg2ysgci0jepqf.lambda-url.us-west-2.on.aws') ||
  'http://localhost:8000';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true'
  }
});

// Add auth token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

class PostsService {
  static async login(username, password) {
    try {
      const response = await api.post('/auth/login', { username, password });
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  static logout() {
    localStorage.removeItem('authToken');
  }

  static isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }

  static async recrawlPost(postId) {
    const response = await api.post(`/findings/${postId}/recrawl`);
    return response.data;
  }

  static async getPosts() {
    if (USE_AWS) {
      return this.getPostsViaS3();
    } else {
      const response = await api.get('/findings');
      return response.data;
    }
  }

  static async getPostsViaS3() {
    const presignResponse = await api.get('/findings-url');
    const presignedUrl = presignResponse.data.url;
    const dataResponse = await axios.get(presignedUrl, {
      responseType: 'json'
    });
    return dataResponse.data;
  }

  static async updateStatusByClusterId(clusterId, updates) {
    const response = await api.put(`/findings/cluster/${clusterId}`, updates);
    return response.data;
  }

  static async updatePost(postId, updates) {
    const response = await api.put(`/findings/${postId}`, updates);
    return response.data;
  }

  static async triggerCrawl(params) {
    const response = await api.post('/crawl', params);
    return response.data;
  }

  static async triggerReport(params) {
    const response = await api.post('/report', params);
    return response.data;
  }

  static async triggerAnalyze(params) {
    const response = await api.post('/analyze', params);
    return response.data;
  }
}

export default PostsService;